import { render, staticRenderFns } from "./SpeedSettings.vue?vue&type=template&id=6257e5f6&scoped=true&"
import script from "./SpeedSettings.vue?vue&type=script&lang=ts&"
export * from "./SpeedSettings.vue?vue&type=script&lang=ts&"
import style0 from "./SpeedSettings.vue?vue&type=style&index=0&id=6257e5f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6257e5f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTimePicker } from 'vuetify/lib/components/VTimePicker';
installComponents(component, {VCheckbox,VCol,VContainer,VRow,VSwitch,VTextField,VTimePicker})
